// Autogenerated file
export const notificationFlagsEnum = {
    PushNotifications: "PushNotifications",
    MailNotifications: "MailNotifications",
    ChatNotifications: "ChatNotifications",
    WebPushNotifications: "WebPushNotifications",
};
export const notificationFlags = [
    { label: "Push в моб. приложении", value: "PushNotifications", intValue: 1 },
    { label: "E-mail", value: "MailNotifications", intValue: 2 },
    { label: "Уведомления в чате", value: "ChatNotifications", intValue: 8 },
    { label: "Push в браузере", value: "WebPushNotifications", intValue: 16 },
];
